import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppTradeSmartLoginComponent } from './trade-smart.component';

@NgModule({
    declarations: [
        AppTradeSmartLoginComponent
    ],
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule
    ]
})
export class AppTradeSmartLoginModule { }
